import { KpiType } from '../constants';
import { getClippedTargetItems, getKpiDistribution } from '../utils';
import { useUser } from './useController';
import { StorePerformanceItem } from './useTransaction';

type KpiDistributionParams = {
  kpiName: KpiType;
  performanceItems: StorePerformanceItem[];
};

export const useKpiTargetDistribution = () => {
  const {
    get: { kpiTargetsProps },
  } = useUser();

  const getKpiTargetDistribution = (params: KpiDistributionParams) => {
    const { kpiName, performanceItems } = params;
    const kpiDistribution = getKpiDistribution(kpiTargetsProps, kpiName);

    return getClippedTargetItems({
      kpiDistribution,
      performanceItems,
    });
  };

  return { getKpiTargetDistribution };
};
